import { useEffect, useRef } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const state = params.get("state");
    const savedState = sessionStorage.getItem("oauth_state");

    const run = async () => {
      // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
      if (!code || !state || state !== savedState) {
        window.location.replace("/");
        return;
      }
      sessionStorage.removeItem("oauth_state");
      try {
        const redirectUri = window.location.origin + "/auth/google";
        const res = await api.post("/auth/google/callback", { code, redirect_uri: redirectUri });
        setUser(res.data);
        window.location.replace("/app");
      } catch (e) {
        console.error("Google callback failed:", e);
        window.location.replace("/");
      }
    };
    run();
  }, [setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="flex flex-col items-center gap-3 text-slate-500" data-testid="auth-loading">
        <Loader2 className="h-6 w-6 animate-spin text-[#003366]" />
        <p className="text-sm">Signing you in…</p>
      </div>
    </div>
  );
}
